module.exports = "<div>\n\n    <!-- LEFT NAV -->\n    <div class=\"col-md-3 left_col\">\n        <side-nav></side-nav>\n    </div>\n    <!-- END LEFT NAV -->\n\n    <!-- TOP NAV -->\n    <div class=\"top_nav\">\n        <top-nav></top-nav>\n    </div>\n    <!-- END TOP NAV -->\n\n    <!-- PAGE CONTENT -->\n    <div class=\"right_col\" role=\"main\">\n        <router-outlet></router-outlet>\n    </div>\n\n    <!-- FOOTER CONTENT -->\n    <footer></footer>\n    <!-- END FOOTER CONTENT -->\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/containers/main/main.component.html
// module id = ../../../../../src/app/containers/main/main.component.html
// module chunks = main